import PoetAllInfoMap from './PoetAllInfoPoetMap.jsx';

export default PoetAllInfoMap;
